function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#003C58",
  d: "M31.025 9.204c-.038-.594-.528-1.055-1.123-1.055h-5.955v-1.76C23.947 2.868 20.606 0 16.5 0S9.053 2.867 9.053 6.39v1.759H3.098c-.595 0-1.085.461-1.123 1.055l-1.599 25.6c-.019.311.091.614.304.842.212.225.51.354.82.354h30c.31 0 .608-.129.82-.354.213-.228.323-.53.304-.841L31.025 9.204zM11.303 6.39c0-2.283 2.332-4.14 5.197-4.14s5.197 1.857 5.197 4.14v1.759H11.303v-1.76zm-2.25 4.009v2.443c0 .621.504 1.125 1.125 1.125.62 0 1.125-.504 1.125-1.125V10.4h10.394v2.443c0 .621.504 1.125 1.125 1.125s1.125-.504 1.125-1.125V10.4h4.897l.975 15.6H3.181l.975-15.6h4.897zM2.697 33.75l.39-6.25h26.826l.39 6.25H2.697z"
});

var SvgShoppingCart = function SvgShoppingCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-cart.4cc7b705.svg";
export { ForwardRef as ReactComponent };